//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {
  'use strict';

  $('[data-search=\'entities\']').on('change', '.filter__item', function (ev) {
    $(this).parents('form').eq(0).submit();
  });

  $('[data-mapitem]').on('click', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var $last = $('[data-container="items"]').children().last().find('a[id]');

    $('body').addClass('loading');
    window.location = $this.attr('href') + '#' + $last.attr('id');
  });
})();
